import ApplicationController from './application_controller';

// Lazy-loads the assign-patients modal HTML for a given AuthorizedSigner
// when the "+ Assign" button is clicked, then swaps it into the
// shared modal shell and shows it via Bootstrap.
//
// The signers index page renders N rows; rendering N modals up front would
// waste DOM. Each click fetches the modal partial for that specific signer.
export default class extends ApplicationController {
  static targets = ['modal', 'content'];

  async open(event) {
    event.preventDefault();
    const url = event.currentTarget.getAttribute('href');
    if (!url) return;

    try {
      const response = await fetch(url, {
        headers: { 'Accept': 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) throw new Error(`Failed to load: ${response.status}`);
      const html = await response.text();
      this.contentTarget.innerHTML = html;

      // Bootstrap 4 modal show via jQuery (Ambiki uses BS4 + jQuery).
      if (window.$) {
        window.$(this.modalTarget).modal('show');
      } else {
        this.modalTarget.classList.add('show');
        this.modalTarget.style.display = 'block';
      }
    } catch (err) {
      console.error('assign-patients modal load failed:', err);
    }
  }
}
